import './title.css'

const Title = ({item, fonte}) => {
  return (
<p className='tittle' >{item} </p>
  )
}

export default Title